/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：542
 */

"use strict"

export { PEDOMETER_WIDGET as a }
export { o as b }
var /* [auto-meaningful-name] */PEDOMETER_WIDGET = "PEDOMETER_WIDGET"
var o = {
  type: PEDOMETER_WIDGET,
  icon: "icon-widget-pedometer",
  title: "widgetName",
  platforms: ["android"],
  isGlobalWidget: true,
  isInvisibleWidget: true,
  properties: [
    {
      key: "stepCount",
      label: "stepCount",
      valueType: "number",
      defaultValue: 0,
      readonly: true
    }
  ],
  methods: [
    {
      key: "startStepUpdate",
      label: "startStepUpdate",
      params: []
    }, {
      key: "stopStepUpdate",
      label: "stopStepUpdate",
      params: []
    }, {
      key: "resetStepCount",
      label: "resetStepCount",
      params: []
    }
  ],
  events: [
    {
      key: "onStepCountChange",
      label: "onStepCountChange",
      params: [
        {
          key: "stepCount",
          label: "stepCount",
          valueType: "number"
        }
      ],
      blockOptions: {
        icon: "%{BKY_BLOCK_PEDOMETER_ICON}"
      }
    }, {
      key: "onPedometerNotAvailable",
      label: "onPedometerNotAvailable",
      params: [],
      blockOptions: {
        icon: "%{BKY_BLOCK_PEDOMETER_ICON}"
      }
    }, {
      key: "onPedometerPermissionFail",
      label: "onPedometerPermissionFail",
      params: [],
      blockOptions: {
        icon: "%{BKY_BLOCK_PEDOMETER_ICON}"
      }
    }
  ]
}
export default PEDOMETER_WIDGET
